import React from 'react';
import {withTranslation} from "react-i18next";

const TagTitle = ({record, t}) => (
    <span>{t('Tag # %{tag}', {tag: record.label})}</span>
);

export default withTranslation()(TagTitle);